import {DesktopProfile} from './desktop';

export const ProfileScreen = DesktopProfile;
